module.exports = __webpack_public_path__ + "static/media/dir-3.91556a34.jpg";